module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "legals-layout take-place column"
  }, [_c('div', {
    staticClass: "legals-master column"
  }, [_c('div', {
    staticClass: "legals-title"
  }, [_vm._v("\n\t\t\t\tConditions Générales d'Utilisation\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "legals-body"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("Patrimoffice exerce en qualité de Conseil en Investissements Financiers (CIF).")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("La règlementation (article 325-3 du règlement général de l’AMF) prévoit pour les CIF l’obligation de remettre à son Client un Document d’Entrée en Relation (DER), avant la signature d’une lettre de mission.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Les informations communiquées dans ce DER sont des informations légales et réglementaires obligatoires qui permettent au Client d’avoir une vision du périmètre d’activités de la société, et des conditions d’exercice des différents métiers exercés par le gestionnaire de patrimoine.")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Ce document est en accès libre sur notre site et peut être téléchargé "), _c('a', {
    attrs: {
      "href": "https://www.patrimoffice.com/document-entree-en-relation/"
    }
  }, [_vm._v("ici")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-767ff58e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Legal/CGU.vue
// module id = 1150
// module chunks = 0